import { useTranslation } from 'react-i18next';

import { TAllBeneficiariesFields } from '../../hooks';

import { ButtonFilter } from '@/ui-kit/table-filters/ButtonFilter';
import { FormFilters } from '@/ui-kit/table-filters/FormFilters';
import { SearchFilter } from '@/ui-kit/table-filters/SearchFilter';

interface IAllBeneficiariesFilterProps {
  fields: TAllBeneficiariesFields;
}

export function AllBeneficiariesFilters({ fields }: IAllBeneficiariesFilterProps) {
  const { t } = useTranslation();
  return (
    <FormFilters className="justify-between" testid="allBeneficiaries-filters">
      <ButtonFilter
        options={fields.type.values}
        selected={[fields.type.value]}
        onChange={(values) => fields.type.handleChange(values[0].toString())}
      />
      <SearchFilter
        value={fields.search.value}
        onChange={fields.search.handleChange}
        placeholder={t('pages.currentProfiles.beneficiaries.filters.placeholder')}
        options={fields.search.options}
      />
    </FormFilters>
  );
}
